import { subCategoryResultSchema } from "@/schema/assessment-results/SubCategoryResult";
import { z } from "zod";

export const mainCategoryResultSchema = z.object({
  id: z.number(),
  content: z.string(),
  score: z.number().nullable(),
  sub_category_results: z.array(subCategoryResultSchema),
});

export type MainCategoryResult = z.infer<typeof mainCategoryResultSchema>;
